import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { callApi } from '../../utils/callApi';
import { ApiEvents } from '../../utils/SocketEvents';
import { ClickCallAction, GetCallAction, TypeClickCallToActionR, TypeGetCallToActioR } from './actions';
import ActionTypes, { TCallToAction } from './types';

function* getCallToActionWorker(action: ReturnType<typeof GetCallAction.request>): Generator {
  const { data, callBack } = action.payload as TypeGetCallToActioR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.callToAction,
    })) as TCallToAction;
    yield put(GetCallAction.success(resp));
  } catch (e) {
    success = false;
    yield put(GetCallAction.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}
function* clickCallToActionWorker(action: ReturnType<typeof ClickCallAction.request>): Generator {
  const { data, callBack } = action.payload as TypeClickCallToActionR;

  let success = true;
  try {
    yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.clickCallToAction,
    });
  } catch (e) {
    success = false;
    yield put(ClickCallAction.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}
function* watchRequest() {
  yield takeEvery(ActionTypes.GET_CALL_TO_ACTION_R, getCallToActionWorker);
  yield takeEvery(ActionTypes.CLICK_CALL_TO_ACTION_R, clickCallToActionWorker);
}

export default function* callToActionSaga() {
  yield all([fork(watchRequest)]);
}
